// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__kc12q","shine":"Skeleton_shine__F2SmI"};